export const ROUTER = {
  ONBOARDING: "/",
  LOGIN: "/login",
  RECOVERY: "/recovery",
  HOME: "/home",
  ABOUT: "/about",
  EXIT: "/exit",
  FIRST_CONSULT: "/first-consult",
  CLOSE_CONSULT: "/close-consult",
  DOCUMENTATION: "/documentation/:idPacient",
  AVALIATION: "/avaliation",
  MAINTENANCE: "/maintenance",
  CLINICAL_RECORD_USER: "/clinical-record-user/:idPacient",
  ODONTOGRAMA_USER: "/odontograma-user/:idPacient",
  CLINICAL: "/clinical",
  NOTES: "/notes/:idPacient",
  AVALIATION_USER: "/avaliation-user/:idPacient",
  EVOLUTION: "/evolution/:idPacient",
  RECORD_PHYSICAL: "/record-physical/:idPacient",
  CLINICAL_EVALUATION: "/clinical-evaluation",
  CLINICAL_BUDGET: "/clinical-budget",
  CLINICAL_BUDGET_LIST: "/clinical-budgets/:idPacient",
  CLINICAL_BUDGET_EDIT: "/clinical-budget-edit/:idOrcamento",
};
